import { render, staticRenderFns } from "./FactFindLiabilityCard.vue?vue&type=template&id=224ebe6a&"
import script from "./FactFindLiabilityCard.vue?vue&type=script&lang=ts&"
export * from "./FactFindLiabilityCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports